// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input, OnInit } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'ddj-spinner',
    templateUrl: './ddj-spinner.component.html',
    styleUrls: ['./ddj-spinner.component.scss'],
})
export class DdjSpinnerComponent implements OnInit {
    @Input() phrase: string;
    @Input() hideBackground: boolean;

    constructor() {}

    ngOnInit(): void {}
}
